import accountSelectors from './accountSelectors';
import deathPrayersSelectors from './deathPrayersSelectors';
import massesSelectors from './massesSelectors';
import fetchSelectors from './fetchSelectors';
import accountOptionsSelectors from './accountOptionsSelectors';
import paymentLinkSelectors from './paymentLink';

export default {
  ...accountSelectors,
  ...deathPrayersSelectors,
  ...massesSelectors,
  ...fetchSelectors,
  ...accountOptionsSelectors,
  ...paymentLinkSelectors,
};
